<template>
  <form class="form-signin">
    <h1 class="h3 mb-3 font-weight-normal">Anbieter löschen</h1>
    <user-menu-select-feed v-on:changed="onSelectedProviderChanged" />
    <user-menu-button-bar
      ActionName="Löschen"
      v-on:executeCancel="onExecuteCancel"
      v-on:executeAction="onExecuteAction"
    />
  </form>
</template>

<script>
import { mapActions } from "vuex";
import UserMenuButtonBar from "./User.Menu.ButtonBar.vue";
import UserMenuSelectFeed from "./User.Menu.SelectFeed.vue";

export default {
  name: "User.Menu.Delete",
  components: {
    UserMenuSelectFeed,
    UserMenuButtonBar
  },
  data: function() {
    return {
      selectedProvider: ""
    };
  },
  computed: {
    provider() {
      let provider = [];
      this.$store.state.UserFeeds.items.forEach(element => {
        element.urls.forEach(feed => {
          provider.push({ name: feed.name, value: feed.url });
        });
      });
      return provider;
    }
  },
  methods: {
    ...mapActions(["deleteUserFeed"]),
    onExecuteAction: function() {
      if (this.$el.checkValidity()) {
        let category = this.$store.state.UserFeeds.items[
          this.selectedProvider.indexCategory
        ];
        //Wenn der letzte Feed gelöscht wird, dann zur "News"-Kategory springen
        if (category.isUserDefined && category.urls.length == 1)
          this.$router.push({ path: "news" });

        this.deleteUserFeed(this.selectedProvider).then(() =>
          this.$emit("executeStop")
        );
      } else this.$el.classList.add("was-validated");
    },
    onExecuteCancel: function() {
      this.$emit("executeStop");
    },
    onSelectedProviderChanged: function(aProviderValue) {
      this.selectedProvider = aProviderValue;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}

.form-signin select {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
